export const buyMedicine = {
  path: "/buy-medicine",
  name: "buyMedicine",
  hidden: false,
  component: () => import("@/components/buyMedicine/index"),
  meta: {
    title: "Beli Obat",
    icon: "fa-capsules",
    roles: ["pasien", "dokter", "hct"],
    icon1: "fa-shopping-cart"
  }
};
export default buyMedicine;



// WEBPACK FOOTER //
// ./src/router/modules/buy-medicine.js